import type { Me } from "@/resources/me";
import { apiClient } from "./apiClient";

class MeService {
  async get(): Promise<Me | null> {
    try {
      const response = await apiClient.get<Me>("/me");
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to get me:", error);
      return null;
    }
  }
}

export const meService = new MeService();
